import React from "react";
import clientConfig from "../../client-config";
import PortableText from "./portableText";
import * as styles from './whyChooseUs.module.css';


function WCUItem(props) {
    return (
        <div className={styles.wcuItem}>
            <div className={styles.wcuHeading}>
                <img class="inline-block align-middle" src={require('../images/message-icon.png').default} alt="Message Icon" />
                <h4 class="inline-block align-middle">{props.item.title}</h4>
            </div>
            <div className={styles.wcuContent}>
                <PortableText blocks={props.item.desc} />
            </div>
        </div>
    );
}
  
export default WCUItem;